import { createContext } from 'react';
import type { Dispatch } from 'react';

import { Select, Option, Flex, Button, Icon } from '@pega/cosmos-react-core';
import type { Action } from '@pega/cosmos-react-core';
import type { ViewSelectorProps } from '@pega/cosmos-react-core/lib/components/ListToolbar/ListToolbar.types';
import { ConditionBuilder } from '@pega/cosmos-react-condition-builder';
import FieldSelector from '@pega/cosmos-react-condition-builder/lib/components/ConditionBuilder/RhsControls/FieldSelector';

import { demoFields } from '../../condition-builder/ConditionBuilder/props.mock';

export const actions: Action[] = ['Action 1', 'Action 2', 'Action 3'].map(text => ({
  text,
  id: text,
  icon: 'filter'
}));

export const mockViews: ViewSelectorProps['views'] = [
  { id: '1', text: 'Data view 1', selected: true },
  { id: '2', text: 'Data view 2', selected: false },
  { id: '3', text: 'Data view 3', selected: false }
];

export const StagedStateDispatchContext = createContext<Dispatch<object>>(() => {});

const GroupByMock = () => {
  return (
    <Flex container={{ direction: 'column', gap: 2 }}>
      <Flex
        container={{
          justify: 'start',
          alignItems: 'center',
          direction: 'row',
          wrap: 'nowrap',
          itemGap: 0.5
        }}
        item={{ grow: 1 }}
      >
        <Icon name='drag' />
        <Flex item={{ basis: '50%' }}>
          <FieldSelector fields={[]} value='' onChange={() => {}} aria-label='Field' />
        </Flex>
        <Flex item={{ basis: '50%' }}>
          <Select label='Select' aria-label='Select'>
            <Option> </Option>
            <Option>Item A</Option>
          </Select>
        </Flex>
        <Button aria-label='Delete group' icon variant='simple'>
          <Icon name='trash' />
        </Button>
      </Flex>
      <Button variant='link' aria-label='Add a group'>
        <Flex
          container={{
            inline: true,
            alignItems: 'start',
            gap: 1
          }}
          as='span'
        >
          <Icon name='plus' />
          <span>Add</span>
        </Flex>
      </Button>
    </Flex>
  );
};

export const FilterRenderer = () => {
  return <ConditionBuilder fields={demoFields} />;
};

export const GroupRenderer = () => {
  return <GroupByMock />;
};
